export const enum RedisCacheStatusEnum {
  UNKNOWN = -1,
  ENABLED = 0,
  DISABLED = 1,
  PENDING_ENABLE = 2,
  PENDING_DISABLE = 3,
}

export interface SyncStatusResultInterface {
  status: RedisCacheStatusEnum;
  websiteId: number;
}

export interface SyncStatusErrorInterface {
  websiteId: number;
  reason: string;
}

export interface StatusUpdateResultInterface {
  status: RedisCacheStatusEnum;
  websiteId: number;
}

export interface StatusUpdateErrorInterface {
  currentStatus: RedisCacheStatusEnum;
  websiteId: number;
  reason: string;
}

export default interface RedisCacheRepositoryInterface {
  enableRedisCacheByWebsiteId(websiteId: number): Promise<void>;

  disableRedisCacheByWebsiteId(websiteId: number): Promise<void>;

  getRedisCacheStatusByWebsiteId(websiteId: number): Promise<SyncStatusResultInterface>;

  getRedisCacheSyncedStatusByWebsiteId(websiteId: number): Promise<void>;
}
